import { variousFormatter } from './various';

export function taxStatusFormatter(abbreviate = false) {
  return (data) => {
    const taxStatuses: string[] = Array.isArray(data.value)
      ? data.value
      : [data.value];

    return variousFormatter(abbreviate)({ value: taxStatuses });
  };
}
